module.exports = __webpack_public_path__ + "static/privatePublishImage-577b910fe983b35a55599bb626a21a9d.png";